import { Component, inject, Input, OnInit } from '@angular/core';
import { IProduct } from '../../../../../IProduct';
import { SlideModalController } from '../../../../../../../slide-modal.service';
import {
  DeviceActionStackService,
  EdroNetworkManager,
} from '../../../../../../manager/edro-network-manager';
import { getPoolMasterClass } from '../../../../../../ECoSystemsHelper';
import { P00030 } from '../../../../P00030';
import { P00032 } from '../../../../P00032';
import { P0003601EnSavoirPlusComponent } from '../../../EnSavoirPlus/p0003601-en-savoir-plus/p0003601-en-savoir-plus.component';
import { FunctionParametersSettingsClockScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-settings-clock-screen/function-parameters-settings-clock-screen.component';
import { FunctionParametersSettingClockWeekScreenComponent } from '../../../../../../../../components/ecosystems/function-parameters-setting-clock-week-screen/function-parameters-setting-clock-week-screen.component';
import { P00039DataRxTxIndex } from '../../../../P00039Sync';
import { P0003601ProgrammeFiltrationAuto } from '../../../Enum/P0003601ProgrammeFiltrationAuto';
import { LabelConfigurationComponent } from '../../../../../../../../components/ecosystems/label-configuration/label-configuration.component';
import { LabelDescriptionComponent } from '../../../../../../../../components/ecosystems/label-description/label-description.component';
import { LargedLinkComponent } from '../../../../../../../../components/ecosystems/larged-link/larged-link.component';
import { TranslatePipe } from '@ngx-translate/core';
import { TwoChoicesControlComponent } from '../../../../../../../../components/ecosystems/two-choices-control/two-choices-control.component';
import { SwitchConfigurationComponent } from '../../../../../../../../components/ecosystems/switch-configuration/switch-configuration.component';
import { P0003601SeuilTemperatureFiltration2424 } from '../../../Enum/P0003601SeuilTemperatureFiltration2424';
import { getTemperatureType } from '../../../../../../helper/temperature';
import { AffichageWarningComponent } from '../../../../../../../../components/ecosystems/affichage-warning/affichage-warning.component';
import { IonLabel } from '@ionic/angular/standalone';
import { P0003601CapteurTemperatureEnum } from '../../../Enum/P0003601CapteurTemperatureEnum';
import { P0003601SeuilTemperatureHorsGel } from '../../../Enum/P0003601SeuilTemperatureHorsGel';
import { FunctionParametersSettingClockVSScreenComponent } from '../../../Component/function-parameters-setting-clock-vsscreen/function-parameters-setting-clock-vsscreen.component';
import { FunctionParametersSettingClockWeekVSScreenComponent } from '../../../Component/function-parameters-setting-clock-week-vsscreen/function-parameters-setting-clock-week-vsscreen.component';
@Component({
  selector: 'app-p0003601-filtration-parameters',
  templateUrl: './p0003601-filtration-parameters.component.html',
  styleUrls: ['./p0003601-filtration-parameters.component.scss'],
  imports: [
    LabelConfigurationComponent,
    LabelDescriptionComponent,
    LargedLinkComponent,
    TranslatePipe,
    TwoChoicesControlComponent,
    SwitchConfigurationComponent,
    AffichageWarningComponent,
    IonLabel,
  ],
})
export class P0003601FiltrationParametersComponent implements OnInit {
  @Input() productClass: IProduct | null = null;

  private slideModalService: SlideModalController =
    inject(SlideModalController);

  private edroNetworkManager: EdroNetworkManager = inject(EdroNetworkManager);

  public actionStack: DeviceActionStackService | null = null;

  constructor() {
    this.openEnSavoirPlus = this.openEnSavoirPlus.bind(this);
  }

  async openEnSavoirPlus() {
    const modal = await this.slideModalService.create({
      component: P0003601EnSavoirPlusComponent,
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();
  }

  ngOnInit() {
    this.actionStack = new DeviceActionStackService(
      this.productClass!,
      this.edroNetworkManager,
      null,
    );
  }

  hasProduitP00030() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00030()) ?? 0;
  }

  hasProduitP00032() {
    const p = this.edroNetworkManager.getPoolContext()!.pool!;
    const master = getPoolMasterClass(p);

    return master?.hasProduct(p!, new P00032()) ?? 0;
  }

  async goToFunctionParametersSettingsClockScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fvsPHorlogeVitesseSemainePPH'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage2,
        'fvsPHorlogeVitesseSemainePPH',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPHA') +
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPHB'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage,
        'fvsPHorlogeVitesseJoursPPHA',
        hj.substring(0, 120),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage2,
        'fvsPHorlogeVitesseJoursPPHB',
        hj.substring(120),
      );
      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingsClockPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockVSScreenComponent,
      componentProps: {
        value:
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPEA') +
          this.actionStack!.getValue('fvsPHorlogeVitesseJoursPPEB'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;

      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage3,
        'fvsPHorlogeVitesseJoursPPEA',
        hj.substring(0, 120),
      );
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPHorlogeVitesseJoursPPEB',
        hj.substring(120),
      );

      this.actionStack!.commit();
    }
  }

  async goToFunctionParametersSettingClockWeekPPEScreen() {
    const modal = await this.slideModalService.create({
      component: FunctionParametersSettingClockWeekVSScreenComponent,
      componentProps: {
        value: this.actionStack!.getValue('fvsPHorlogeVitesseSemainePPE'),
      },
      config: {
        position: 'right',
        size: 'medium',
        showBackdrop: true,
        backdropDismiss: true,
      },
      animationConfig: {
        duration: 300,
        easing: 'ease-out',
      },
    });

    await modal.present();

    const { data } = await modal.onDidDismiss();
    if (data) {
      const hj = data.value;
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationVS_Parametrage4,
        'fvsPHorlogeVitesseSemainePPE',
        hj,
      );
      this.actionStack!.commit();
    }
  }

  protected readonly P00039DataRxTxIndex = P00039DataRxTxIndex;
  protected readonly P0003601ProgrammeFiltrationAuto =
    P0003601ProgrammeFiltrationAuto;

  protected readonly P0003601SeuilTemperatureFiltration2424 =
    P0003601SeuilTemperatureFiltration2424;
  protected readonly getTemperatureType = getTemperatureType;
  protected readonly P0003601CapteurTemperatureEnum =
    P0003601CapteurTemperatureEnum;
  protected readonly P0003601SeuilTemperatureHorsGel =
    P0003601SeuilTemperatureHorsGel;
}
